// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"a1ec7e21","279":"79327b20"}[chunkId] + ".chunk.js";
};